import * as React from "react";

import "./CustomError.css";

export interface IProps {
  errorText: string;
}

// This component is needed to show the same type of
// error message for Checkbox components with validation since
// it doesn't support the `invalid` props
const CustomError: React.FC<IProps> = (props) => {
  return (
    <div className="error-element">
      <span className="error-icon"></span>
      {props.errorText}
    </div>
  );
};

export default CustomError;
